import FormLid from "../components/formLid";
import FormControlReport from "../components/formResult";
import ReportResultForm from "../components/reportForm";
import { columnsLID } from "./lid.colums";
import { columnsActivity } from "./activity.columns";

export const typesReports = [
  {
    label: "Reportar sólo LID",
    value: "report_lid",
  },
];

export const anexosOptions = [
  {
    label: "Anexo 1 - Muestras",
    value: "anexo_1",
  },
  {
    label: "Anexo 2 - Incidencias",
    value: "anexo_2",
  },
  {
    label: "Anexo 3 - Evolución",
    value: "anexo_3",
  },
  {
    label: "Agregar carta",
    value: "letter",
  },
];

export const samplesOptions = [
  {
    label: "AT Alfa Total",
    value: "at_alfa_total",
  },
  {
    label: "BT Beta total PP",
    value: "bt_beta_total_pp",
  },
  {
    label: "BR Beta total/resto",
    value: "br_beta_total_resto",
  },
  {
    label: "BT Beta Total",
    value: "bt_beta_total",
  },
  {
    label: "BR Beta resto",
    value: "br_beta_resto",
  },
  {
    label: "Tritio en aguas",
    value: "tritium_water",
  },
  {
    label: "Tritio en aire",
    value: "tritium_air",
  },
  {
    label: "I-131",
    value: "i_131",
  },
  {
    label: "Sr 89",
    value: "sr_89",
  },
  {
    label: "Sr 90",
    value: "sr_90",
  },
  {
    label: "Sr 89/90",
    value: "sr_89_90",
  },
  {
    label: "Esp. Gamma - GT",
    value: "esp_gamma_gt",
  },
  {
    label: "Esp. Gamma - IG",
    value: "esp_gamma_ig",
  },
  {
    label: "Esp. Alfa",
    value: "esp_alfa",
  },
  {
    label: "Esp. Alfa Am 241",
    value: "esp_alfa_am_241",
  },
  {
    label: "Esp. Gamma CM 243+244",
    value: "esp_gamma_cm_243_244",
  },
  {
    label: "Esp. Gamma P238",
    value: "esp_gamma_p238",
  },
  {
    label: "Esp. Gamma P239+240",
    value: "esp_gamma_p239_240",
  },
  {
    label: "Fe-55",
    value: "fe_55",
  },
  {
    label: "Ni-63",
    value: "ni_63",
  },
  {
    label: "Dosim.",
    value: "dosim",
  },
];

export enum TypeReport {
  REPORT_RESULT = "results",
  REPORT_LID = "lid_csn",
  REPORT_CONTROL = "control",
}

export const configButtonsConditioning: Record<string, any> = {
  results: {
    title: "Informe de resultados",
    component: ReportResultForm,
    type: TypeReport.REPORT_RESULT,
  },
  lid_csn: {
    title: "Informe de LID y niveles de CSN",
    component: FormLid,
    type: TypeReport.REPORT_LID,
  },
  control: {
    title: "Informe de control de resultados",
    component: FormControlReport,
    type: TypeReport.REPORT_CONTROL,
  },
};

export const setsConfigLidActivity = [
  {
    label: "LID",
    set: "lid",
    columns: columnsLID,
  },
  {
    label: "Actividad",
    set: "actividad",
    columns: columnsActivity,
  },
];
